import Typography from '@mui/material/Typography';
import ConfirmationDialog from 'components/system/ConfirmationDialog';
import useDeletePaymentMethod from 'hooks/useDeletePaymentMethod';
import Hint from 'components/system/Hint';

const DeleteCardDialog = ({
  onClose, onSuccess, onCancel, paymentMethodId,
}) => {
  const { mutate } = useDeletePaymentMethod(onSuccess);

  const handleDeleteClick = async () => {
    mutate(paymentMethodId);
  };
  return (
    <ConfirmationDialog
      title="Delete Attached Card"
      onClose={onClose}
      onConfirm={handleDeleteClick}
      onCancel={onCancel}
      confirmText="Delete"
      reversed
    >
      <Typography variant="body2">
        Are you sure you want to delete the card?
      </Typography>
    </ConfirmationDialog>
  );
};

export default DeleteCardDialog;
